import { render } from "./ListHarvestProcesses.vue?vue&type=template&id=6531cd48"
import script from "./ListHarvestProcesses.vue?vue&type=script&lang=js"
export * from "./ListHarvestProcesses.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/organization/projections/query_estimated_harvest/list_harvest_processes.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Forganization%2Fprojections%2Fquery_estimated_harvest%2FListHarvestProcesses.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__